import type { SVGProps } from 'react';
const SvgPlaySquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 0H2C.897 0 0 .897 0 2v20c0 1.103.897 2 2 2h20c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2zm0 22H2V2h20v20c.003 0 0 0 0 0z" />
    <path d="M20.5 3h-17c-.275 0-.5.225-.5.5v17c0 .275.225.5.5.5h17c.275 0 .5-.225.5-.5v-17c0-.275-.225-.5-.5-.5zM20 20H4V4h16v16z" />
    <path d="M9.25 15.934a.503.503 0 0 0 .503-.003l6-3.5a.5.5 0 0 0 0-.862l-6-3.5a.5.5 0 0 0-.75.431v7a.498.498 0 0 0 .247.434zM10 9.372 14.506 12 10 14.628V9.372z" />
  </svg>
);
export default SvgPlaySquare;
